import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

import { ROUTE_TRANSITION } from "../../../../app.animation";
import { downloadCsvFromBase64 } from "../../../../core/utils/utils";
import { DataGridComponent } from "../../../shared/data-grid/data-grid.interface";
import { AssetSummaryDTO } from "../../../shared/dto-models/assetSummaryDTO.model";
import { GridDataSource } from "../../../shared/data-grid/data-grid.datasource";
import { AssetService } from "../../../services/asset.service";
import { DataGridService } from "../../../shared/data-grid/data-grid.service.interface";
import { DataGridColumn } from "../../../shared/models/dataGridColumn.model";
import { PropertyType } from "../../../../core/utils/property-type";

@Component({
    // tslint:disable-next-line:component-selector
    selector: "bs-asset",
    templateUrl: "./asset-table.component.html",
    styleUrls: ["./asset-table.component.scss"],
    animations: [...ROUTE_TRANSITION],
    standalone: false
})
export class AssetTableComponent
  implements DataGridComponent<AssetSummaryDTO>, OnInit
{
  dataSource: GridDataSource<AssetSummaryDTO>;
  dataGridService: DataGridService<AssetSummaryDTO>;

  columns: DataGridColumn[] = [];

  constructor(
    public translate: TranslateService,
    private assetService: AssetService,
  ) {
    this.dataGridService = assetService;

    this.columns = [
      {
        name: "buildingId",
        property: "buildingId",
        visible: false,
        isModelProperty: true,
        filterValue: null,
        hidden: true,
      },
      {
        name: this.translate.instant("ASSET.COLUMNS.ASSETNAME"),
        property: "assetName",
        visible: true,
        isModelProperty: true,
        sortable: true,
        flexGrow: "0.4",
      },
      {
        name: this.translate.instant("ASSET.COLUMNS.BUILDINGNAME"),
        property: "buildingName",
        visible: true,
        isModelProperty: true,
        sortable: true,
        flexGrow: "0.4",
        sticky: true,
      },
      {
        name: this.translate.instant("ASSET.COLUMNS.STRUCTUREREF"),
        property: "structureRef",
        visible: true,
        isModelProperty: true,
        sortable: true,
        flexGrow: "0.4",
      },
      {
        name: this.translate.instant("ASSET.COLUMNS.SERVICENAME"),
        property: "serviceName",
        visible: true,
        isModelProperty: true,
        sortable: true,
        flexGrow: "0.8",
      },
      {
        name: this.translate.instant("ASSET.COLUMNS.LOCATIONNAME"),
        property: "locationName",
        visible: true,
        isModelProperty: true,
        sortable: true,
        flexGrow: "0.4",
      },
      {
        name: this.translate.instant("ASSET.COLUMNS.LOCATIONTYPENAME"),
        property: "locationTypeName",
        visible: true,
        isModelProperty: true,
        sortable: true,
        flexGrow: "0.4",
      },
      {
        name: this.translate.instant("ASSET.COLUMNS.ZONENAME"),
        property: "zoneName",
        visible: true,
        isModelProperty: true,
        sortable: true,
        flexGrow: "0.4",
      },
      {
        name: this.translate.instant("ASSET.COLUMNS.CREATEDDATE"),
        property: "createdDate",
        visible: false,
        isModelProperty: true,
        isDateRange: true,
        sortable: true,
        flexGrow: "0.6",
        modelPropertyType: PropertyType.DateTime,
      },
      {
        name: this.translate.instant("ASSET.COLUMNS.UPDATEDDATE"),
        property: "updatedDate",
        visible: false,
        isModelProperty: true,
        isDateRange: true,
        sortable: true,
        flexGrow: "0.6",
        modelPropertyType: PropertyType.DateTime,
      },
      {
        name: this.translate.instant("ASSET.COLUMNS.STATUS"),
        property: "status",
        propertyId: "statusId",
        visible: true,
        isModelProperty: true,
        sortable: true,
        flexGrow: "0.2",
        isHeaderList: true,
        headerListAPI: "statuses",
        // initial value
        filterValue: 3,
      },
      // Should be the last column
      {
        name: this.translate.instant("ASSET.COLUMNS.ACTIONS"),
        property: "actions",
        visible: true,
      },
    ] as DataGridColumn[];
  }

  ngOnInit() {
    this.dataSource = new GridDataSource<AssetSummaryDTO>(this.dataGridService);
  }

  openColumnsPanel(dataGrid: { filterOpen: boolean }): void {
    dataGrid.filterOpen = !dataGrid.filterOpen;
  }

  exportCsv() {
    this.assetService
      .exportCsv(
        this.dataSource.paginator.pageSize,
        this.dataSource.paginator.pageIndex,
        this.dataSource.sort.active,
        this.dataSource.sort.direction,
        this.dataSource.filter,
      )
      .subscribe((r) => {
        if (r) {
          downloadCsvFromBase64(r, "asset.csv");
        }
      });
  }
}
